import { randomUUID } from "node:crypto";

import {
  HEADER_CORRELATION_ID,
  HEADER_ORCHARD_IDENTITY_ID,
} from "@theorchard/ows-headers";

export interface HeaderProvider {
  getHeaders(): Record<string, string> | Promise<Record<string, string>>;
}

export interface IdentityProviderConfig {
  identityId: string;
}

export class IdentityProvider implements HeaderProvider {
  identityId: string;

  constructor(config: IdentityProviderConfig) {
    this.identityId = config.identityId;
  }

  async getHeaders(): Promise<Record<string, string>> {
    return {
      [HEADER_CORRELATION_ID]: randomUUID(),
      [HEADER_ORCHARD_IDENTITY_ID]: this.identityId,
    };
  }
}
